<script>
export default {
    name: "IconArrowRight"
}
</script>

<template>
    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
              stroke-width="2" d="M19 12H5m14 0-4 4m4-4-4-4"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
